import React from 'react';
import {
	UseCommunicationDataAddress,
	UseCommunicationDataEmail,
	UseCommunicationDataPhone,
} from '@gov-nx/component/web';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useEPeticeEditContext } from '@gov-nx/module/page';
import { LayoutGap } from '@gov-nx/ui/web';
import { ElementIds } from './utils';

export const WizardStep2ContactDetails = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const context = useEPeticeEditContext();
	const {
		formStep2,
		code,
		isProcessing,
		personCommunicationData,
		zakladatelTyp,
		email,
		phone,
		resetEmailField,
		resetPhoneField,
	} = context;
	const tsn = getLocalizeCurried(code);

	if (!formStep2) return null;

	return (
		<LayoutGap gap="m">
			<h2
				className="text-headline-m!"
				id={ElementIds.zakladatel}>
				{tsn('formular.nadpis.kontakt-zakladatel')}
			</h2>

			<UseCommunicationDataEmail
				email={email}
				personCommunicationData={personCommunicationData}
				fields={{
					_useEmail: {
						field: {
							name: '_useEmail',
							isDisabled: isProcessing,
							label: {
								children: `${tsn('formular.pole.kontakt-email')}:`,
							},
						},
					},
					email: {
						field: {
							name: 'email',
							placeholder: tsn('formular.placeholder.email'),
						},
						label: {
							children: '',
						},
					},
				}}
				onReset={resetEmailField}
				wcagLabels={{
					edit: tsn('formular.akce.wcag.upravit-email'),
					cancel: tsn('formular.tlacitko.zrusit'),
				}}
			/>

			<UseCommunicationDataPhone
				personCommunicationData={personCommunicationData}
				fields={{
					_usePhone: {
						field: {
							name: '_usePhone',
							isDisabled: isProcessing,
							label: {
								children: `${tsn('formular.pole.kontakt-telefon')}:`,
							},
						},
					},
					phone: {
						field: {
							name: 'phone',
							placeholder: tsn('formular.placeholder.telefon'),
						},
						label: { children: '' },
					},
				}}
				phone={phone}
				wcagLabels={{
					edit: tsn('formular.akce.wcag.upravit-tel'),
					cancel: tsn('formular.tlacitko.zrusit'),
				}}
				onReset={resetPhoneField}
			/>

			{zakladatelTyp === 'FO' ? (
				<UseCommunicationDataAddress
					personCommunicationData={personCommunicationData}
					fields={{
						_useAddress: {
							field: {
								name: '_useAddress',
								isDisabled: isProcessing,
								label: {
									children: `${tsn('formular.pole.kontakt-adresa')}:`,
								},
							},
						},
						address: {
							field: {
								name: 'adresa',
								placeholder: tsn('formular.placeholder.adresa'),
							},
							label: { children: '' },
						},
					}}
					onReset={personCommunicationData.control.isEditingAddress.setFalse}
					address={formStep2.formDefinition.formMethods.getValues(
						'adresa.adresaText'
					)}
					wcagLabels={{
						cancel: tsn('formular.tlacitko.zrusit'),
						edit: tsn('formular.akce.wcag.upravit-tel'),
					}}
				/>
			) : null}
		</LayoutGap>
	);
};
